import React from 'react';

import {css} from 'emotion';
import PropTypes from 'prop-types';

import {ReactComponent as LoadingSvg} from 'staticImages/icons/Loading-Spinner.svg';
const propTypes = {
  /**
   * Width of the SVG. will be applied to height as well
   */
  width: PropTypes.string,
};

// Newsela colored circular loading spinner
class LoadingSpinner extends React.PureComponent {
  render() {
    const {width = '96px'} = this.props;

    const styling = css`
      display: block;
      margin: 2em auto;
      width: ${width};
      height: ${width};
    `;
    return (
      <LoadingSvg role="alert" aria-live="Assertive" className={styling} alt="Loading"/>
    );
  }
}

LoadingSpinner.propTypes = propTypes;
export default LoadingSpinner;
